import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'contact/suggestions';

export const useContactSuggestionsInfiniteQuery = ({
	enabled,
	pageSize = 25,
}: {
	enabled: boolean;
	pageSize?: number;
}) => {
	const userSession = useUserSession();
	return useInfiniteQuery({
		enabled,
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IContact>>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { pageSize, pageToken: pageParam },
					urlPath: BASE_QUERY_KEY,
				}),
				'GET'
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		queryKey: [BASE_QUERY_KEY, pageSize],
		initialPageParam: '',
	});
};

export const invalidateContactSuggestions = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
